<template lang="pug">
    form(class="_row bd", @submit.prevent="submit")
        ib-col(class="xl8 insetx-16", :class="$media.xl ? 'border-end': ''")
            MaturityDate(@showResults="setMaturityDate", ref="maturityDate")
            YieldToWorst(@minMaxYield="getMinMaxYield", @getRates="checkFields", ref="ytw")
            CouponRate(@minMaxCoupon="getMinMaxCoupon", @getRates="checkFields", ref="couponRate")
            TreasuryType(v-show="isTreasury", @type="getType", ref="treasury")
            Ratings(
                v-show="showRatings",
                @showMoodymin="getMoodyMin"
                @showMoodymax="getMoodyMax"
                @showSpmin="getSPMin"
                @showSpmax="getSPMax",
                @showRateRelation="getRateRelation",
                @ratingType="getRatingType",
                :disableAnd="rateSelected",
                :disableXand="secondRateSelected",
                ref="ratings"
            )
            CountrySelector(
                v-show="showCountry",
                :isNonUS="isNonUS",
                @issuerCountry="getIssuerCountry",
                ref="country"
            )
            CurrencySelector(
                v-show="showCurrency",
                :isMuni="isMuni",
                @currencySelect="getCurrency",
                ref="currency"
            )
        Industries(v-if="isUSCorp", @onChange="setAllIndustries", ref="industries")
        ib-col(v-else-if="isNonUS || !isMuni")
        ib-col(v-else, class="insetx-32 xl4")
            div(class="insety-16 border-bottom")
                label(class="bold bond-title fg70") {{ $t('additional_features') }}
            table(class="additional-filters text-center insety-16 border-bottom")
                tr
                    td
                        ib-checkbox(name="general", val="true", v-model="generalObligationOnly")
                    td(class="text-start") {{ $t('include_general_obligation_bonds') }}
                tr
                    td
                        ib-checkbox(name="revenue", val="true", v-model="revenueOnly")
                    td(class="text-start") {{ $t('include_revenue_bonds') }}
            USStates(v-if="isMuni",
                @stateSelect="getUSState",
                ref="usStates")

        SubmitForm(:disabled="disabled", @onReset="resetFilters")
</template>

<script>
    import MaturityDate from './MaturityDate.vue'
    import YieldToWorst from './YieldToWorst.vue'
    import CouponRate from './CouponRate.vue'
    import Ratings from './Ratings.vue'
    import TreasuryType from './TreasuryType.vue'
    import CountrySelector from './CountrySelector.vue'
    import CurrencySelector from './CurrencySelector.vue'
    import Industries from './Industries.vue'
    import SubmitForm from './SubmitForm.vue'
    import USStates from './USStates.vue'
    import mxGb from '../mixin/mixin-global'

    export default {
        name: 'ScanFilters',
        mixins: [mxGb],

        components: {
            MaturityDate,
            YieldToWorst,
            CouponRate,
            Ratings,
            TreasuryType,
            CountrySelector,
            CurrencySelector,
            Industries,
            SubmitForm,
            USStates,
        },

        props: {
            isMuni: {
                type: Boolean,
                default: false
            },
            isNonUS: {
                type: Boolean,
                default: false
            },
            isUSCorp: {
                type: Boolean,
                default: false
            },
            isTreasury: {
                type: Boolean,
                default: false
            },
            showCountry: {
                type: Boolean,
                default: false
            },
            showCurrency: {
                type: Boolean,
                default: false
            },
            showRatings: {
                type: Boolean,
                default: false
            },
            curTabName: String,
        },

        data() {
           return {
                endDate: '',
                startDate: '',
                industries: '',
                industryLabel: '',
                invalid: '',
                issuerCountry: {},
                yieldMin: '',
                yieldMax: '',
                couponMin: '',
                couponMax: '',
                currency: '',
                currencyLabel: '',
                cusipId: '',
                cusip: '',
                moodyLow: '',
                moodyHigh: '',
                ratingType: '',
                spLow: '',
                spHigh: '',
                selectRelations: '',
                treasuryType: '',
                generalObligationOnly: undefined,
                revenueOnly: undefined,
                usState: '',
                stateLabel: '',
                filters: [],
                disabled: false,
                rateSelected: false,
                secondRateSelected: true,
                maturityDates: []
            }
        },

        methods: {
            disableSubmit(invalid, length) {
                if (length != 9 && length != 0) {
                    this.invalid = true;
                } else {
                    this.invalid = invalid;
                }
                this.checkFields();
            },
            getMinMaxYield(val) {
                this.yieldMin = val[0];
                this.yieldMax = val[1];
            },
            getMinMaxCoupon(val) {
                this.couponMin = val[0];
                this.couponMax = val[1];
            },
            getType(selected) {
               this.treasuryType = selected;
            },
            checkFields() { 
                const ydMin = parseFloat(this.yieldMin);
                const ydMax = parseFloat(this.yieldMax);
                const cpMin = parseFloat(this.couponMin);
                const cpMax = parseFloat(this.couponMax);
                if (this.invalid === true) {
                    this.disabled = true;
                    return;
                }
                if (isNaN(this.yieldMin) || isNaN(this.yieldMax) || isNaN(this.couponMin) || isNaN(this.couponMax)) {
                    this.disabled = true;
                    return;
                }
                if (this.yieldMin != '' && this.yieldMax != '' && ydMin > ydMax) {
                    this.disabled = true;
                    return;
                }
                if (this.couponMin != '' && this.couponMax != '' && cpMin > cpMax) {
                    this.disabled = true;
                    return;
                }
                if (this.moodyLow != '' && this.moodyHigh != '' && this.moodyLow === this.moodyHigh ) {
                    this.$alert(this.$t('alert_bond_rating'));
                    this.disabled = true;
                    return;
                }
                if (this.spLow != '' && this.spHigh != '' && this.spLow === this.spHigh ) {
                    this.$alert(this.$t('alert_bond_rating'));
                    this.disabled = true;
                    return;
                }
                if (this.maturityDates[0] != '' && this.maturityDates[1] != '' && this.maturityDates[0] > this.maturityDates[1]) {
                    this.$alert(this.$t('correct_maturity_date'));
                    this.disabled = true;
                    return;
                }
                this.disabled = false;
            },
            getRatingType(rating) {
                this.ratingType = rating;
            },
            getMoodyMin(moodyFrom, selectRelations) {
                this.moodyLow = moodyFrom;
                this.getRateRelation(selectRelations);
                this.checkFields();
            },
            getMoodyMax(moodyTo, selectRelations) {
                this.moodyHigh = moodyTo;
                this.getRateRelation(selectRelations);
                this.checkFields();
            },
            getSPMin(spFrom, selectRelations) {
                this.spLow = spFrom;
                this.getRateRelation(selectRelations);
                this.checkFields();
            },
            getSPMax(spTo, selectRelations) {
                this.spHigh = spTo;
                this.getRateRelation(selectRelations);
                this.checkFields();
            },
            getRateRelation(selectRelations) {
                if (this.moodyLow === '' || this.moodyHigh === '' || this.spLow === '' || this.spHigh === '') {
                    this.rateSelected = true;
                    this.secondRateSelected = true;
                    this.selectRelations = '';
                    return;
                }
                if (selectRelations) {
                    if (!selectRelations[0] && selectRelations[1]) {
                        this.secondRateSelected = true;
                        this.rateSelected = false;
                        this.selectRelations = 'or';
                    }
                    if (!selectRelations[0] && !selectRelations[1]) {
                        this.secondRateSelected = true;
                        this.selectRelations = 'or';
                    }
                    if (selectRelations[0]) {
                        this.secondRateSelected = false;
                        this.selectRelations = "and";
                        if(selectRelations[1]) {
                            this.selectRelations = "xand";
                        }
                    }
                }
                if (this.moodyLow != '' && this.moodyHigh != '' && this.spLow != '' && this.spHigh != '') {
                    this.rateSelected = false;
                }
            },
            getCurrency(selected) {
                this.currency = selected;
                this.currencyLabel = this.currency === '' ? this.$t('ALL') : this.currency;
                this.$emit('findCurrency', this.currency);
            },
            getIssuerCountry(issuer) {
                this.issuerCountry = issuer;
                this.$emit('checkCountry', this.issuerCountry);
            },
            getUSState(selected, stateLabel) {
                this.usState = selected;
                this.stateLabel = stateLabel;
            },
            passConId(id, cusip) {
                this.cusipId = id;
                this.cusip = cusip;
                this.checkFields();
            },
            prepareSearch() {
                this.filters = [
                    {
                        "code": "maturityDateAbove",
                        "value": this.startDate
                    },
                    {
                        "code": "maturityDateBelow",
                        "value": this.endDate
                    },
                ];
                if (this.isUSCorp) {
                    const USCorps = [
                        {
                            "code": "industryLike",
                            "value": this.industries
                        }
                    ];
                    this.filters = [ ...this.filters, ...USCorps];
                }
                const yieldAndCoupon = [
                    {
                        "code": "bondAskYieldAbove",
                        "value": this.yieldMin
                    },
                    {
                        "code": "bondAskYieldBelow",
                        "value": this.yieldMax
                    },
                    {
                        "code": "couponRateAbove",
                        "value": this.couponMin
                    },
                    {
                        "code": "couponRateBelow",
                        "value": this.couponMax
                    }
                ];
                this.filters = [ ...this.filters, ...yieldAndCoupon];
                if (this.showRatings) {
                    const ratings = [
                        {
                            "code": "moodyRatingAbove",
                            "value": this.moodyLow
                        },
                        {
                            "code": "moodyRatingBelow",
                            "value": this.moodyHigh
                        },
                        {
                            "code": "spRatingAbove",
                            "value": this.spLow
                        },
                        {
                            "code": "spRatingBelow",
                            "value": this.spHigh
                        }
                    ];
                    if(this.curTabName === 'Corporate Bonds' || this.curTabName === 'US Muni Bonds') {
                        ratings.push({
                            "code" : "ratingsRelation",
                            "value" : this.selectRelations
                        });
                    }
                    if(this.selectRelations != 'none' && !ratings[4]) {
                        ratings.push({
                            "code" : "ratingsRelation",
                            "value" : this.selectRelations
                        });
                    }
                    if(this.selectRelations === '') {
                        ratings.pop();
                    }
                    this.filters = [ ...this.filters, ...ratings];
                }
                if (this.showCurrency) {
                    this.filters.push(
                        {
                            "code": "currencyLike",
                            "value": this.currency
                        }
                    );
                }
                if (this.generalObligationOnly) {
                    this.filters.push(
                        {
                            "code": "bondGeneralObligationIs",
                            "value": this.generalObligationOnly === true
                        }
                    );
                }
                if (this.revenueOnly) {
                    this.filters.push(
                        {
                            "code": "bondRevenueIs",
                            "value": this.revenueOnly === true
                        }
                    );
                }
                if (this.isMuni) {
                    this.filters.push(
                        {
                            "code": "bondUSStateLike",
                            "value": this.usState
                        }
                    );
                }
                if (this.showCountry) {
                    if (this.issuerCountry.value) {
                        this.filters.push(
                            {
                                "code": "issuerCountryIs",
                                "value": this.issuerCountry.value
                            }
                        );
                    } else {
                        this.filters.push(
                            {
                                "code": "issuerCountryIs",
                                "value": ""
                            }
                        );
                    }
                }
                if (this.isTreasury) {
                     this.filters.push(
                        {
                            "code": "bondAssetSubTypeStrBeginsWithOneOf",
                            "value": this.treasuryType
                        }
                    );
                }
            },
            resetFilters() {
                this.$refs.maturityDate.reset();
                this.$refs.ytw.reset();
                this.$refs.couponRate.reset();
                if (this.isUSCorp || this.isMuni) {
                    this.$refs.ratings.reset();
                }
                if (this.isUSCorp || this.isNonUS) {
                    this.$refs.currency.reset();
                    this.currency = '';
                    this.currencyLabel = this.$t('ALL');
                }
                if (this.isMuni) {
                    this.$refs.currency.reset();
                    this.currency = 'USD';
                    this.currencyLabel = 'USD';
                }
                if (this.showCountry) {
                    this.$refs.country.reset();
                }
                if (this.isTreasury) {
                    this.$refs.treasury.reset();
                }
                if (this.isUSCorp) {
                    this.$refs.industries.selectAll();
                } else if (this.isMuni) {
                    this.$refs.usStates.reset();
                }
                this.cusipId = '';
                this.cusip = '';
                this.yieldMin = '';
                this.yieldMax = '';
                this.couponMin = '';
                this.couponMax = '';
                this.endDate = '';
                this.startDate = '';
                this.industries = '';
                this.invalid = '';
                this.generalObligationOnly = undefined;
                this.revenueOnly = undefined;
                this.usState = '';
                this.stateLabel = '',
                this.disabled = false;
                this.$emit('reset');
            },
            setAllIndustries(val) {
                this.industries = val;
                this.industryLabel = this.industries === '' ? this.$t('ALL') : this.industries.replace(/,/g, " ").split('#').join(', ');
            },
            setMaturityDate(value) {
                if(value.length === 0) {
                    this.startDate = '';
                    this.endDate = '';
                    return;
                }
                if(value[0]) {
                    let start = value[0];
                    start = start.replace(/\-/g, '');
                    const Y = start.substr(0,4);
                    const D = start.substr(6,start.length);
                    const M = start.substr(4,2);
                    this.startDate = Y + M + D;
                } else {
                    this.startDate = '';
                }
                if(value[1]) {
                    let end = value[1];
                    end = end.replace(/\-/g, '');
                    const YE = end.substr(0,4);
                    const DE = end.substr(6,end.length);
                    const ME = end.substr(4,2);
                    this.endDate = YE + ME + DE;
                } else {
                    this.endDate = '';
                }
                this.maturityDates = [value[0], value[1]];
                this.checkFields();
            },
            submit() {
                this.prepareSearch();
                const fields = {
                    couponMin: this.couponMin,
                    couponMax: this.couponMax,
                    endDate: this.endDate,
                    startDate: this.startDate,
                    yieldMin: this.yieldMin,
                    yieldMax: this.yieldMax,
                    stateLabel: this.stateLabel,
                    issuerLabel: this.issuerCountry.label,
                    currencyLabel: this.currencyLabel,
                    industryLabel: this.industryLabel,
                    treasuryType: this.treasuryType,
                    cusipId: this.cusipId,
                    cusip: this.cusip
                };
                if (this.inCP) {
                    fields.moodyLow = this.moodyLow;
                    fields.moodyHigh = this.moodyHigh;
                    fields.spHigh = this.spHigh;
                    fields.spLow = this.spLow;
                } else {
                    fields.rating = this.ratingType;
                }
                this.$emit('onSubmit', this.filters, fields);
            },

            getAdditionalFeaturesFromUrl() {
                if (this.subFilters) {
                    this.generalObligationOnly = this.getFilterValue('bondGeneralObligationIs') === "true";
                    this.revenueOnly = this.getFilterValue('bondRevenueIs') === "true";
                }
            }
        },

        mounted() {
            this.getAdditionalFeaturesFromUrl();
        },

        watch: {
            generalObligationOnly(val) {
                if (val) {
                    this.generalObligationExclude = undefined;
                }
            },
            revenueOnly(val) {
                if (val) {
                    this.revenueExclude = undefined;
                }
            },
        }
 }
</script>

<style lang="less" scoped>
.additional-filters {
    tr {
        width: 100%;
        line-height: 1.8em;
    }
    td:first-child {
        min-width: 10%;
        text-align: start;
        vertical-align: top;
    }

}
</style>
